import {faReceipt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import moment from 'moment';
import 'moment/locale/fr';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {withTranslation} from 'react-i18next';
import {Alert, Card, Label, Spinner} from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import styled from 'styled-components';
import DateRangePicker from '../../../common/components/Dates/DateRangePicker';
import {AttributeDiv} from '../../../common/components/layout/InputCol';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import SelectTags from '../../../common/components/SelectTags';
import {TitleButton} from '../../../common/components/StyledComp';
import SelectUserBrand from '../../../common/components/User/SelectUserBrand';
import isAfterDay from 'react-dates/lib/utils/isAfterDay';
import ColoredHeader from '../../../common/components/layout/ColoredHeader';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import {flowRight as compose} from 'lodash';
import {Link} from 'react-router-dom';

const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;

const FullTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: .5px solid #d0d1df;
  resize: none;
  border-radius: 5px;
`;

const ColItemsCenter = styled(Col)`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const MargedAlert = styled(Alert)`
  margin-top: 10px;
`;

const MailInput = styled(MandatoryInput)`
  font-size: inherit;
`;

const ProInput = styled(Input)`
  width: 190px;
`;

const MailCopyCheckbox = styled(Input)`
  width: 440px;
`;

const GRAPHQL_QUERY_CAN_EXPORT_RECEIPTS = gql`
  query canExportReceipts($filtersInput: ExportReceiptsFiltersInput!) {
    canExportReceipts(filtersInput: $filtersInput) {
      id
      sendEmailAllowed
      totalReceipts
    }
  }
`;

const GRAPHQL_MUTATION_EXPORT_RECEIPTS = gql`
  mutation exportReceipts($filtersInput: ExportReceiptsFiltersInput!, $emailInput: ExportReceiptsEmailInput!) {
    exportReceiptsByEmail(filtersInput: $filtersInput, emailInput: $emailInput) {
      id
      sendEmailAllowed
      totalReceipts
    }
  }
`;

const initialState = {
  startDate: null,
  endDate: null,
  listTags: [],
  listBrands: [],
  mailRecipient: '',
  copyMail: true,
  messageMail: '',
  submittedStep1: false,
  submittedStep2: false,
  part1Checked: null,
  messageInfo: null,
  errorMessageStep1: null,
  errorMessageStep1Bold: null,
  errorMessageStep2: null,
  loading: false,
  loadingQuery: false,
  success: false,
  isPro: true,
};

class ExportReceipts extends Component {

  constructor(props, context) {
    super(props, context);
    moment.locale('fr');
  }

  state = initialState;

  modificationOnStep1 = () => {
    const {t} = this.props;
    if (this.state.submittedStep1) {
      this.setState({
        part1Checked: false,
        errorMessageStep1: t('exportReceipts.messageInfo.modificationStep1Submission') ,
        errorMessageStep1Bold: '"' + t('exportReceipts.submitPart1') + '"',
      });
    }
  };

  handleChangeDate = (startDate, endDate) => {
    this.setState({
      startDate,
      endDate,
    });
    this.modificationOnStep1();
  };

  handleProCheckboxChange = (e) => {
    this.setState({isPro: e.target.checked});
    this.modificationOnStep1();
  };

  handleSelectTagChange = (options) => {
    const newTagList = [];
    if (!(options === null || options.length === 0)) {
      options.forEach(function(option) {
        newTagList.push(option);
      });
    }

    this.setState({listTags: newTagList});

    this.modificationOnStep1();
  };

  handleSelectBrandChange = (options) => {
    const newBrandsList = [];
    if (!(options === null || options.length === 0)) {
      options.forEach(function(option) {
        newBrandsList.push(option);
      });
    }

    this.setState({listBrands: newBrandsList});

    this.modificationOnStep1();
  };

  handleChangeMailRecipient = (name, e) => {
    this.setState({mailRecipient: e});
  };

  handleCopyMailCheckboxChange = (e) => {
    this.setState({copyMail: e.target.checked});
  };

  isOutsideDateRange = (day) => {
    let dayIsBlocked = false;
    if (isAfterDay(day, moment())) {
      dayIsBlocked = true;
    }
    return dayIsBlocked;
  };

  onSubmitPart1 = (e) => {
    e.preventDefault();
    const {client, t} = this.props;
    this.setState({
      errorMessageStep1: null,
      errorMessageStep1Bold: null,
      errorMessageStep2: null,
      success: false,
      loadingQuery: true,
      submittedStep1: false,
    });
    client
      .query({
        query: GRAPHQL_QUERY_CAN_EXPORT_RECEIPTS,
        variables: {
          filtersInput: {
            startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
            endDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            isPro: this.state.isPro ? this.state.isPro : null,
            tags: this.state.listTags.map(({value}) => value),
            brands: this.state.listBrands.map(({value}) => value),
          },
        },
      })
      .then(({data}) => {
        const totalReceipts = data.canExportReceipts.totalReceipts;
        const payload = {
          part1Checked: data.canExportReceipts.sendEmailAllowed,
          loadingQuery: false,
        };

        if (data.canExportReceipts.sendEmailAllowed) {
          payload.messageInfo = t('exportReceipts.messageInfo.readyToExport', {totalReceipts});
          payload.submittedStep1 = true;
        } else {
          if (data.canExportReceipts.totalReceipts === 0) {
            payload.errorMessageStep1 = t('exportReceipts.messageInfo.noTicket');
          } else {
            payload.errorMessageStep1 = t('exportReceipts.messageInfo.tooBig');
          }
        }
        this.setState(payload);
      })
      .catch(error => {
        console.error(error);
        this.setState({
          loadingQuery: false,
          errorMessageStep1: t('exportReceipts.messageInfo.exportFailed'),
        });
      });
  };

  onSubmitPart2 = (e) => {
    e.preventDefault();
    const {client, t} = this.props;
    this.setState({
      loading: true,
      success: false,
      errorMessageStep2: null,
    });
    if (!this.state.mailRecipient && !this.state.copyMail) {
      this.setState({
        errorMessageStep2: t('exportReceipts.messageInfo.atLeastOneEmail'),
        loading: false,
      });
      return;
    }

    let filtersInput = {
      startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.state.endDate).format('YYYY-MM-DD'),
      tags: this.state.listTags.map(({value}) => value),
      brands: this.state.listBrands.map(({value}) => value),
    };

    if (this.state.isPro) {
      filtersInput = {
        ...filtersInput,
        isPro: this.state.isPro,
      };
    }

    client
      .mutate({
        mutation: GRAPHQL_MUTATION_EXPORT_RECEIPTS,
        variables: {
          filtersInput,
          emailInput: {
            sendTo: this.state.mailRecipient,
            copyToSender: this.state.copyMail,
            message: this.state.messageMail,
          },
        },
      })
      .then(({data}) => {
        this.setState({
          ...initialState,
          success: true,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          errorMessageStep2: t('exportReceipts.messageInfo.exportFailed'),
          loading: false,
        });
      });
  };

  render() {
    const {t} = this.props;
    const {currentUser} = this.props;

    return (
      <Screen
        header={<Metadata meta={t('meta')} title={t('exportReceipts.title')}/>}
        leftTitle={
          <>
            <FontAwesomeIcon icon={faReceipt} color={'rgb(201,0,95)'}/>
            <Span className="route-name">{t('exportReceipts.title')}
              <small>
                <Span className="route-name">{t('exportReceipts.title2')}</Span>
              </small>
            </Span>
          </>
        }>
        <Container>
          <Card>
            <ColoredHeader>{t('exportReceipts.step1')}</ColoredHeader>
            <form className={'card-body'}>
              <Row>
                <Col xs={6}>
                  <DateRangePicker
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    isOutsideRange={this.isOutsideDateRange}
                    onDatesChange={({startDate, endDate}) => this.handleChangeDate(startDate, endDate)}/>
                </Col>
                <ColItemsCenter xs={6}>
                  <Label check>
                    <ProInput type="checkbox"
                      value={this.state.isPro}
                      checked={this.state.isPro}
                      onChange={e => this.handleProCheckboxChange(e)}
                    />{' '}
                    {t('exportReceipts.pro')}
                  </Label>
                </ColItemsCenter>
                {(!this.state.startDate || !this.state.endDate) && (
                  <Col xs={12}>
                    <MargedAlert color="info">{t('exportReceipts.messageInfo.selectDates')}</MargedAlert>
                  </Col>
                )}
              </Row>
              <Row className="export-input-row">
                <Col xs={6}>
                  <SelectTags
                    value={this.state.listTags}
                    userTags={true}
                    onChange={option => this.handleSelectTagChange(option)}
                  />
                </Col>
                <Col xs={6}>
                  <SelectUserBrand
                    value={this.state.listBrands}
                    onChange={option => this.handleSelectBrandChange(option)}
                  />
                </Col>
                {(!this.state.listBrands.length || !this.state.listTags.length) && (
                  <Col xs={12}>
                    <MargedAlert color="info">{t('exportReceipts.messageInfo.preciseSelect')}</MargedAlert>
                  </Col>
                )}
                {this.state.errorMessageStep1 !== null && (
                  <Col xs={12}>
                    <MargedAlert color="danger">
                      {this.state.errorMessageStep1}
                      {this.state.errorMessageStep1Bold !== null && <strong>{this.state.errorMessageStep1Bold}</strong>}
                    </MargedAlert>
                  </Col>
                )}
                {this.state.messageInfo && this.state.part1Checked && (
                  <Col xs={12}>
                    <MargedAlert color="success">{t(this.state.messageInfo)}</MargedAlert>
                  </Col>
                )}
              </Row>
              <Col xs={12}>
                <div className="popin-buttons">
                  <TitleButton
                    type="submit"
                    disabled={this.state.startDate === null || this.state.endDate === null || this.state.loadingQuery}
                    onClick={this.onSubmitPart1}>
                    {this.state.loadingQuery ? <Spinner type="grow" color="light" /> : t('exportReceipts.submitPart1')}
                  </TitleButton>
                </div>
              </Col>
            </form>
          </Card>
        </Container>
        <Container>
          <Card>
            <ColoredHeader>{t('exportReceipts.step2')}</ColoredHeader>
            <form className={'card-body'}>
              <Row>
                <MailInput
                  title={`${t('exportReceipts.email')} : `}
                  type="email"
                  size={6}
                  name="contactEmail"
                  customText={t('exportReceipts.wrongMail')}
                  value={this.state.mailRecipient}
                  onChange={(name, e) => this.handleChangeMailRecipient(name, e)}
                  disabled={!this.state.part1Checked}
                />
                <ColItemsCenter xs={6}>
                  <Label check>
                    <MailCopyCheckbox type="checkbox"
                      value={this.state.copyMail} checked={this.state.copyMail}
                      disabled={!this.state.part1Checked}
                      onChange={e => this.handleCopyMailCheckboxChange(e)}
                    />{' '}
                    {t('exportReceipts.copyMail')}
                  </Label>
                </ColItemsCenter>
              </Row>
              <Row>
                <Col xs={12}>
                  <label className="mandatory-label">
                    <AttributeDiv className="label-name">{t('exportReceipts.message')}</AttributeDiv>
                    <FullTextArea
                      disabled={!this.state.part1Checked}
                      value={this.state.messageMail}
                      onChange={e => this.setState({messageMail: e.target.value})}
                      rows={7}
                    />
                  </label>
                </Col>
                {this.state.errorMessageStep2 !== null && (
                  <Col xs={12}>
                    <MargedAlert color="danger">{t(this.state.errorMessageStep2)}</MargedAlert>
                  </Col>
                )}
                {currentUser.hasActiveSubscription && this.state.success && (
                  <Col xs={12}>
                    <MargedAlert color="success">{t('exportReceipts.messageInfo.exportSuccess')}</MargedAlert>
                  </Col>
                )}
                {!currentUser.hasActiveSubscription && this.state.success && (
                  <Col xs={12}>
                    <MargedAlert color="danger">
                      {t('exportReceipts.messageInfo.exportWithoutSubscription')}
                      <Link to={'/admin/billing'}>
                        {t('exportReceipts.messageInfo.subscribe')}
                      </Link>
                    </MargedAlert>
                  </Col>
                )}
                <Col xs={12}>
                  <div className="popin-buttons">
                    <TitleButton
                      disabled={!this.state.part1Checked || this.state.loading}
                      type="submit"
                      onClick={this.onSubmitPart2}
                    >
                      {this.state.loading ? <Spinner type="grow" color="light" /> : t('exportReceipts.submitPart2')}
                    </TitleButton>
                  </div>
                </Col>
              </Row>
            </form>
          </Card>
        </Container>
      </Screen>
    );
  }
}

ExportReceipts.propTypes = {
  t: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    hasActiveSubscription: PropTypes.bool.isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('ticket'),
  withApollo,
  withLoadedUser,
)(ExportReceipts);
